import { VoicePanel } from '../components/VoicePanel'
import type { PanelPlugin } from './types'

// Voice as a panel contribution — the first `panel` slot plugin. The existing VoicePanel
// component is unchanged; this just registers it into the panel host so it renders as a
// split-screen column on desktop and a full-screen swap on mobile (fixing the old "voice
// hidden on phones" gap). See PLUGIN_MODULES.md → Contribution Points.
export const voicePanel: PanelPlugin = {
  id: 'voice',
  title: 'Voice',
  icon: 'phone',
  render: ({ chatId, workspaceId, onClose }) => (
    <VoicePanel key={chatId} chatId={chatId} workspaceId={workspaceId} onClose={onClose} />
  ),
}
